<img *ngIf="!!imageSrc" [src]="imageSrc" alt="">
<h3 class="empty-state-header" *ngIf="!!title">{{ title }}</h3>
<p *ngIf="!!details">{{ details }}</p>
<ng-content></ng-content>
<iris-button *ngIf="!!buttonText" (click)="handleButtonClick()">
  {{ buttonText }}
</iris-button>
